import { render, staticRenderFns } from "./navigation-tree.vue?vue&type=template&id=3c61be4c&"
import script from "./navigation-tree.vue?vue&type=script&lang=js&"
export * from "./navigation-tree.vue?vue&type=script&lang=js&"
import style0 from "./navigation-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports